import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { OrderWithContext } from '@/models';

@Component({
  name: 'CmgCheckoutPaymentHeader',
})
export default class CmgCheckoutPaymentHeader extends Vue {
  @Prop({ required: true, type: Boolean })
  hasError!: boolean;

  get order(): OrderWithContext | null {
    return this.$services.order.getCurrentOrder();
  }

  get orderTotal(): string {
    if (!this.order) {
      return '';
    }

    return this.$services.utils.formatPrice(this.order.order.orderTotalAmount);
  }
}
